import React from 'react';
import clsx from 'clsx';
import { ReactComponent as InfoIcon } from '../../../../../resources/img/icons/info-grey.svg';
import { ReactComponent as Plus } from '../../../../../resources/img/icons/green_plus.svg';
import { ReactComponent as Minus } from '../../../../../resources/img/icons/red_minus.svg';

const getDifferenceColor = (difference) => {
  if (difference > 0) return '#008420';
  if (difference < 0) return '#AC0002';
  return '#222';
};

const StatsButton = ({ isActive, title, tooltipAnchor, value, onClick, periodLabel, difference }) => {
  return (
    <div className={clsx('cursor-pointer stats-selector-item', { active: isActive })} onClick={onClick}>
      <div className={clsx('d-flex align-items-center gap-4px mb-6px', tooltipAnchor)} style={{ width: 'fit-content' }}>
        <div className="font-medium font-size-12" style={{ color: '#646464' }}>
          {title}
        </div>
        <InfoIcon style={{ display: 'flex', flexShrink: 0 }} />
      </div>
      <div className="font-medium font-md-bold font-size-20 font-size-md-24" style={{ color: '#222', lineHeight: '36px' }}>
        {value}
      </div>
      <div className="d-flex gap-6px mt-12px">
        <div className="d-flex align-items-center">
          {difference > 0 && <Plus />}
          {difference < 0 && <Minus />}
          <div className="font-size-12" style={{ color: getDifferenceColor(difference) }}>
            {Math.abs(difference)}
          </div>
        </div>
        <div className="font-size-12" style={{ color: '#222' }}>
          ({periodLabel})
        </div>
      </div>
    </div>
  );
};

export default StatsButton;
